/* ═══════════════════════════════════════════════════════════
   APOLLO FRAGRANCES — Theme JavaScript
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── Theme Toggle (Auto / Light / Dark) ─── */
  const root = document.documentElement;
  const toggle = document.getElementById('themeToggle');
  const label = document.getElementById('themeLabel');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

  let themeState = localStorage.getItem('apollo-theme') || 'auto';

  function getEffectiveTheme() {
    if (themeState === 'auto') return prefersDark.matches ? 'dark' : 'light';
    return themeState;
  }

  function applyTheme() {
    if (themeState === 'auto') {
      root.removeAttribute('data-theme');
      if (label) label.textContent = 'Auto';
    } else {
      root.setAttribute('data-theme', themeState);
      if (label) label.textContent = themeState === 'light' ? 'Light' : 'Dark';
    }
    localStorage.setItem('apollo-theme', themeState);
    document.body.style.transition = 'background .5s, color .5s';
    setTimeout(() => { document.body.style.transition = ''; }, 600);
  }

  if (toggle) {
    toggle.addEventListener('click', () => {
      const effective = getEffectiveTheme();
      if (themeState === 'auto') {
        themeState = effective === 'dark' ? 'light' : 'dark';
      } else if (themeState === 'light') {
        themeState = 'dark';
      } else {
        themeState = 'auto';
      }
      applyTheme();
    });
  }

  prefersDark.addEventListener('change', () => {
    if (themeState === 'auto') applyTheme();
  });

  applyTheme();

  /* ─── Scroll Reveal ─── */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  /* ─── Quick Add to Cart (Shopify AJAX API) ─── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(res => res.json())
    .then(() => {
      btn.textContent = 'Added ✓';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = 'Add to Bag';
        btn.disabled = false;
      }, 2000);
    })
    .catch(() => {
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = 'Add to Bag';
        btn.disabled = false;
      }, 2000);
    });
  });

  /* ─── Cart Count Updater ─── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ─── Smooth Scroll ─── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(a.getAttribute('href'));
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

})();
